import { Table } from 'antd';
import * as T from '../../../components/Typography';
import { createExerciseUrl } from 'CMS/utils';
const exercisesTableColumns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: 'Title',
    dataIndex: 'title',
    key: 'title',
    render: (title, row) => {
      return <T.Link to={createExerciseUrl(row.id)}>{title}</T.Link>;
    },
  },
  {
    title: 'Key',
    dataIndex: 'key',
    key: 'key',
  },
  {
    title: 'Milestone',
    dataIndex: 'milestone',
    key: 'milestone.title',
    render: (milestone) => {
      return <T.Link>{milestone.title}</T.Link>;
    },
  },
];

const TableComponent = ({ loading, data }) => (
  <Table columns={exercisesTableColumns} dataSource={data} loading={loading} />
);

export default TableComponent;
